/* EL Project Detail — scroll reveal.
   Loaded once per page via the shared assets snippet. Safe to load more than
   once: the guard below makes repeat execution a no-op. */
(function () {
  if (window.__elPdRevealInit) return;
  window.__elPdRevealInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll() {
    document.querySelectorAll('.el-pd .pd-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function init() {
    if (reduce || !('IntersectionObserver' in window)) {
      showAll();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -30px 0px' }
    );

    document.querySelectorAll('.el-pd .pd-reveal').forEach(function (el) {
      observer.observe(el);
    });

    // Re-bind when a section is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('.el-pd .pd-reveal').forEach(function (el) {
        observer.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
